module.exports = __webpack_public_path__ + "img/ticket-badge.789d8112.svg";